import React from 'react'

export const Logo = () => {
  return (
    <div>
        <img src="logo.svg" className='img-fluid' alt="" />
    </div>
  )
}
